import AnchorComponent from '@wix/thunderbolt-elements/src/components/Anchor/viewer/Anchor';


const Anchor = {
  component: AnchorComponent
};


export const components = {
  ['Anchor']: Anchor
};

